import React from 'react';
import Badge from '@components-clean/core/Badge';

const loremIpsum =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec faucibus ornare rhoncus. Sed eu pretium sem, et ' +
    'fringilla elit. Aliquam non odio mattis, porta nulla a, imperdiet orci. Aliquam efficitur ante vitae lacus ' +
    'maximus, nec blandit ligula cursus. Integer in lectus elementum, gravida ex ac, vehicula est. Phasellus egestas ' +
    'purus enim, et efficitur quam accumsan sit amet. Duis eu urna nec nisi vulputate condimentum vitae id mi. ' +
    'Pellentesque tellus tortor, ullamcorper non nisi sit amet, porta scelerisque dolor. Aenean elit quam, accumsan ' +
    'eu tortor vitae, posuere pulvinar arcu. Mauris accumsan vehicula massa, eu aliquam orci.';

const BadgesPage = () => {
    return (
        <div>
            <h2>Badges</h2>
            <div style={{ display: 'grid', gap: '24px' }}>
                <div>
                    <h3>Baseline</h3>

                    <div style={{ display: 'flex', gap: '12px' }}>
                        <div>
                            <h3>Primary</h3>
                            <Badge>Primary</Badge>
                        </div>
                        <div>
                            <h3>Secondary</h3>
                            <Badge variant="secondary">Secondary</Badge>
                        </div>
                    </div>
                </div>

                <div>
                    <h3>With Max Length (default 30ch)</h3>

                    <div style={{ display: 'flex', gap: '12px' }}>
                        <div>
                            <div>10ch</div>
                            <Badge maxWidth="10ch">{loremIpsum}</Badge>
                        </div>
                        <div>
                            <div>30ch</div>
                            <Badge maxWidth="30ch">{loremIpsum}</Badge>
                        </div>
                        <div>
                            <div>50ch</div>
                            <Badge maxWidth="50ch">{loremIpsum}</Badge>
                        </div>
                    </div>
                </div>

                <div>
                    <h3>With Tooltip</h3>

                    <div style={{ display: 'flex', gap: '12px' }}>
                        <div>
                            <div>Primary</div>
                            <Badge tooltip={loremIpsum}>{loremIpsum}</Badge>
                        </div>
                        <div>
                            <div>Secondary</div>
                            <Badge variant="secondary" tooltip={loremIpsum}>
                                {loremIpsum}
                            </Badge>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BadgesPage;
